import Request from "../../model/Request";
import Response from "../../model/Response";
import {RestClient} from "../../util/RestClient";
import {Config} from "../../util/Config";
import PagedResponse from "../../entities/PagedResponse";
import Pagination from "../../entities/Pagination";
import MiscellanyCategory from "../../entities/productOrder/miscellany/MiscellanyCategory";

export module MiscellanyCategoryService {
    export async function get(page: number = 1, pageSize: number = 15, filter?: string, agencyId?: string): Promise<Response<PagedResponse<MiscellanyCategory>>> {
        const url = Config.get("GET_MISCELLANY_CATEGORY_URL", {page, pageSize, filter, agencyId});
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const miscellanyData = response.data?.data;
            const paginationData = response.data?.pagination;
            if (miscellanyData && paginationData) {
                const data = miscellanyData.map((t: any) => new MiscellanyCategory(t.id, t.name, t.description, t.price, t.purchasePrice));
                const pagination = new Pagination(paginationData.currentPage, paginationData.pageSize, paginationData.elementsCount, paginationData.pageCount);
                return new Response<PagedResponse<MiscellanyCategory>>(true, {data, pagination}, response.error)
            }
        }
        return new Response<PagedResponse<MiscellanyCategory>>(false, undefined, response.error, response.status);
    }

    export async function getAll(): Promise<Response<MiscellanyCategory[]>> {
        const url = Config.get("GET_MISCELLANY_CATEGORY_URL", {page: 1, pageSize: 1000, filter: '', agencyId: ''});
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const moneyServiceFeeData = response.data?.data;
            if (moneyServiceFeeData) {
                const data = moneyServiceFeeData.map((t: any) => new MiscellanyCategory(t.id, t.name, t.description, t.price, t.purchasePrice));
                return new Response<MiscellanyCategory[]>(true, data, response.error)
            }
        }
        return new Response<MiscellanyCategory[]>(false, undefined, response.error, response.status);
    }

    export async function find(id: string): Promise<Response<MiscellanyCategory>> {
        const url = Config.get("FIND_MISCELLANY_CATEGORY_URL", {id});
        const request = new Request(url)
        const response = await RestClient.get(request);
        if (response.success) {
            const miscellanyData = response.data;
            if (miscellanyData) {
                const client = new MiscellanyCategory(miscellanyData.id, miscellanyData.name, miscellanyData.description, miscellanyData.price, miscellanyData.purchasePrice);
                return new Response<MiscellanyCategory>(true, client, response.error);
            }
        }
        return new Response<MiscellanyCategory>(true, undefined, response.error, response.status);
    }

    export async function create(miscellany: MiscellanyCategory): Promise<Response<any>> {
        const url = Config.get("CREATE_MISCELLANY_CATEGORY_URL");
        const request = new Request(url, miscellany);
        return await RestClient.post(request);
    }

    export async function update(miscellany: MiscellanyCategory): Promise<Response<any>> {
        const url = Config.get("UPDATE_MISCELLANY_CATEGORY_URL", {id: miscellany.id});
        const request = new Request(url, miscellany);
        return await RestClient.put(request);
    }

    export async function remove(miscellany: MiscellanyCategory): Promise<Response<any>> {
        const url = Config.get("REMOVE_MISCELLANY_CATEGORY_URL", {id: miscellany.id});
        const request = new Request(url);
        return await RestClient.remove(request);
    }

    export async function updatePrice(miscellanyCategoryId: string, price: number): Promise<Response<any>> {
        const url = Config.get("UPDATE_MISCELLANY_CATEGORY_PRICE_URL", {id: miscellanyCategoryId});
        const request = new Request(url, { amount: price });
        return await RestClient.put(request);
    }

}